import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AuthService } from '../authentication/auth.service';

@Injectable({
  providedIn: 'root'
})

export class TokenInterceptorService implements HttpInterceptor {

  private authHeader: string;
  private currentLanguage: string;

  constructor(
    private authService: AuthService,
    private translate: TranslateService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.currentLanguage = 'it';
    if(this.translate.currentLang) {
      this.currentLanguage = this.translate.currentLang;
    }
    
    this.authHeader = `Bearer ${this.authService.accessToken}`;
    request = request.clone({ setHeaders: { "Authorization": this.authHeader, "Accept-Language": this.currentLanguage }});
    return next.handle(request);
  }
}
